/* Stock caps: never let a customer pick more than 9, or more than we have in stock. */
(function () {
  'use strict';
  var S = window.RI_STOCK || {};
  function cap(id) { var c = S[String(id)]; return typeof c === 'number' ? Math.max(0, Math.min(9, c)) : 9; }
  function clamp(input, c) {
    var v = parseInt(input.value, 10);
    if (isNaN(v)) return;
    var lo = parseInt(input.min, 10); if (isNaN(lo)) lo = 0;
    if (v > c) input.value = c;
    if (v < lo) input.value = lo;
  }

  /* product page */
  var q = document.querySelector('[data-qty]');
  var vid = document.querySelector('[data-variant-id]');
  function product() {
    if (!q) return;
    var c = cap(vid && vid.value);
    q.max = Math.max(1, c);
    clamp(q, Math.max(1, c));
  }
  if (q) {
    product();
    q.addEventListener('change', product);
    document.addEventListener('change', function (e) { if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-option')) setTimeout(product, 0); });
  }

  /* basket page */
  Array.prototype.slice.call(document.querySelectorAll('[data-cart-qty]')).forEach(function (i) {
    var id = (i.id || '').replace('Qty-', '').split(':')[0];
    var c = cap(id);
    i.max = c;
    i.addEventListener('change', function () { clamp(i, c); }, true);
  });

  /* bag drawer: block "+" at the limit */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('#bagBody [data-q]');
    if (!b || parseInt(b.getAttribute('data-q'), 10) < 1) return;
    var li = b.closest('.bi'); if (!li) return;
    var id = (li.getAttribute('data-key') || '').split(':')[0];
    var cur = parseInt((li.querySelector('.bi-q span') || {}).textContent, 10) || 0;
    if (cur >= cap(id)) { e.stopPropagation(); e.preventDefault(); }
  }, true);
})();
